import { neturalBlack } from "../../../constants/color";

const CustomerInfoCard = ({ customer }) => {
  if (!customer) return null;

  return (
    <div
      style={{
        border: "1px solid #DADADA",
        borderRadius: "12px",
        padding: "20px",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          fontSize: "18px",
          fontWeight: "600",
          color: neturalBlack,
          marginBottom: "20px",
        }}
      >
        Customer
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <div style={{ color: neturalBlack, fontSize: "16px", fontWeight: "500" }}>
          {customer.name || "—"}
        </div>
         <div style={{ color: neturalBlack, fontSize: "16px", fontWeight: "300" }}>
          {customer.email || "—"}
        </div>
         <div style={{ color: neturalBlack, fontSize: "16px", fontWeight: "300" }}>
          {customer.phone || "—"}
        </div>
      </div>
    </div>
  );
};

export default CustomerInfoCard;
